"use client";

import { DialogClose } from "@/components/atoms/Dialog";
import { cn } from "@/lib/utils";
import { CircleX } from "lucide-react";
import Image from "next/image";

interface PromotionalBannerProps {
  bannerImage: string;
  onBannerClick?: () => void;
}

const PromotionalBanner = ({
  bannerImage,
  onBannerClick,
}: PromotionalBannerProps) => {
  return (
    <div className="relative xs:w-full">
      {/* Close Icon */}
      <DialogClose
        className={cn(
          "xs:-right-4 xs:-top-4 ",
          "absolute sm:right-2 sm:-top-6 z-50",
          "rounded-full bg-black/50 p-2",
          "opacity-70 hover:opacity-100",
          "transition-opacity cursor-pointer",
          "flex items-center justify-center",
          "md:right-4 md:p-2.5"
        )}
        aria-label="Close promotional banner"
      >
        <CircleX className="size-6 text-white md:size-8" />
      </DialogClose>

      {/* Banner Image */}
      <div
        className={cn(
          "cursor-pointer",
          "xs:w-full xs:h-[500px] ",
          "sm:w-[768px] sm:h-[422px]",
          "md:w-[768px] md:h-[422px]",
          "lg:w-[768px] lg:h-[422px]",
          "xl:w-[768px] xl:h-[422px]"
        )}
        onClick={onBannerClick}
      >
        {bannerImage && (
          <Image
            src={bannerImage || ""}
            alt="Promotional banner"
            width={768}
            height={422}
            className={cn("object-cover", "w-full h-full")}
            priority
            fetchPriority="high"
          />
        )}
      </div>
    </div>
  );
};

export default PromotionalBanner;
